export const servicesData = {
  "web-app-development": {
    "slug": "web-app-development",
    "title": "Web & App Development",
    "heroIcon": "fa fa-code",
    "heroBg": "/assets/images/photo-1467232004584-a241de8bcf5d.jpg",
    "overview": {
      "subtitle": "Our Capabilities",
      "title": "What We Deliver",
      "desc": "From simple business websites to complex enterprise SaaS platforms, our development team engineers digital products that perform under pressure. We use modern frameworks, clean architecture, and rigorous QA to ensure what we deliver is ready for real-world growth.",
      "checklist": [
        "Full-stack development across React, Next.js, Vue, Laravel, Node.js & more",
        "Mobile-first, responsive design on every project",
        "Production-ready code with CI/CD pipeline integration",
        "Complete source code ownership \u2014 no lock-in",
        "On-time delivery with transparent, agile project management"
      ]
    },
    "subServices": {
      "subtitle": "Our Capabilities",
      "title": "What We Deliver",
      "items": [
        {
          "icon": "fa fa-desktop",
          "title": "Custom Web Applications",
          "desc": "Bespoke web applications built on React, Next.js, Vue, and Laravel – engineered for your exact workflow, branding, and business logic with pixel-perfect precision."
        },
        {
          "icon": "fa fa-rocket",
          "title": "SaaS Platforms",
          "desc": "End-to-end SaaS products with multi-tenancy, subscription billing, admin dashboards, and auto-scaling cloud infrastructure – built to handle growth from day one."
        },
        {
          "icon": "fa fa-mobile-alt",
          "title": "Mobile Apps (iOS, Android, Flutter)",
          "desc": "Cross-platform and native mobile apps with polished UX, offline support, push notifications, and complete app store publishing – for iOS, Android, and beyond."
        },
        {
          "icon": "fa fa-plug",
          "title": "API Development",
          "desc": "RESTful and GraphQL APIs built for speed, security, and seamless third-party integration – fully documented, version-controlled, and production-tested."
        },
        {
          "icon": "fa fa-desktop",
          "title": "Custom Web Applications",
          "desc": "Scalable, secure, and high-performance web apps"
        },
        {
          "icon": "fa fa-shopping-cart",
          "title": "E-commerce Development",
          "desc": "Shopify, WooCommerce, custom solutions"
        },
        {
          "icon": "fa fa-building",
          "title": "Enterprise Solutions",
          "desc": "CRM, ERP, SaaS platforms"
        }
      ]
    },
    "process": {
      "subtitle": "How We Work",
      "title": "Our Development Process",
      "steps": [
        {
          "num": "01",
          "title": "Discovery & Planning",
          "desc": "We deep-dive into your goals, users, and constraints to create a solid technical blueprint before writing a single line of code."
        },
        {
          "num": "02",
          "title": "Design & Architecture",
          "desc": "UI wireframes, database schemas, and system architecture are designed for performance, security, and future scalability."
        },
        {
          "num": "03",
          "title": "Development & QA",
          "desc": "Agile sprints with continuous testing, code reviews, and client demos ensure quality at every milestone."
        },
        {
          "num": "04",
          "title": "Deployment & Support",
          "desc": "Seamless deployment to production, domain mapping, SSL provisioning, and ongoing maintenance with round-the-clock support."
        }
      ]
    }
  },
  "ui-ux-design": {
    "slug": "ui-ux-design",
    "title": "UI/UX Design",
    "heroIcon": "fa fa-palette",
    "heroBg": "/assets/images/photo-1561070791-2526d30994b5.jpg",
    "overview": {
      "subtitle": "Our Design Offerings",
      "title": "What We Design",
      "desc": "Great design is invisible \u2014 users just feel it. We combine deep user research with world-class visual craftsmanship to create digital experiences that are intuitive, on-brand, and built to convert. From your first wireframe to a fully realised design system, we guide every pixel with purpose.",
      "checklist": [
        "Human-centred design grounded in real user data and behaviour",
        "Clickable Figma prototypes before any development begins",
        "Consistent, scalable design systems for long-term product growth",
        "Accessibility-first approach (WCAG compliant)",
        "Developer-ready design handoff with complete specifications"
      ]
    },
    "subServices": {
      "subtitle": "Our Design Offerings",
      "title": "What We Design",
      "items": [
        {
          "icon": "fa fa-desktop",
          "title": "UI/UX Design",
          "desc": "User-centered interface and experience design"
        },
        {
          "icon": "fa fa-pencil-ruler",
          "title": "Product Design",
          "desc": "End-to-end digital product design solutions"
        },
        {
          "icon": "fa fa-drafting-compass",
          "title": "Wireframing & Prototyping",
          "desc": "Interactive layouts and clickable prototypes"
        },
        {
          "icon": "fa fa-layer-group",
          "title": "Design Systems",
          "desc": "Consistent UI components and scalable design standards"
        }
      ]
    },
    "process": {
      "subtitle": "Our Approach",
      "title": "Our Design Process",
      "steps": [
        {
          "num": "01",
          "title": "Research & Discovery",
          "desc": "We study your users, competitors, and business context to uncover the real design opportunities and constraints."
        },
        {
          "num": "02",
          "title": "Wireframing",
          "desc": "Low-fidelity layouts map out user flows and information architecture before any visual design begins."
        },
        {
          "num": "03",
          "title": "Visual Design",
          "desc": "High-fidelity screens crafted with meticulous attention to typography, colour, spacing, and brand identity."
        },
        {
          "num": "04",
          "title": "Testing & Handoff",
          "desc": "Usability testing with real users, followed by a clean developer handoff with annotated specs and assets."
        }
      ]
    }
  },
  "cloud-devops": {
    "slug": "cloud-devops",
    "title": "Cloud & DevOps",
    "heroIcon": "fa fa-cloud",
    "heroBg": "/assets/images/photo-1451187580459-43490279c0fa.jpg",
    "overview": {
      "subtitle": "Our DevOps Stack",
      "title": "What We Set Up For You",
      "desc": "Modern software demands infrastructure that is as agile as your code. We design, build, and operate Cloud & DevOps pipelines that eliminate manual bottlenecks, reduce deployment risk, and let your engineering team ship with confidence \u2014 every single day.",
      "checklist": [
        "Automated CI/CD pipelines that deploy code in minutes, not days",
        "Container-first architecture with Docker & Kubernetes orchestration",
        "Infrastructure as code with Terraform for reproducible, auditable deployments",
        "Auto-scaling that responds to traffic spikes in real time",
        "Zero-downtime deployments and rollback strategies built in"
      ]
    },
    "subServices": {
      "subtitle": "Our DevOps Stack",
      "title": "What We Set Up For You",
      "items": [
        {
          "icon": "fa fa-infinity",
          "title": "CI/CD Pipeline Setup",
          "desc": "Automated build, test, and deployment pipelines using GitHub Actions, GitLab CI, Jenkins, or CircleCI – ship code confidently and consistently, every time."
        },
        {
          "icon": "fa fa-cubes",
          "title": "Docker & Kubernetes",
          "desc": "Containerise applications with Docker and orchestrate them at scale with Kubernetes for maximum reliability, portability, and efficient resource utilisation."
        },
        {
          "icon": "fa fa-code-branch",
          "title": "Terraform (IaC)",
          "desc": "Infrastructure-as-code with Terraform – provision and manage cloud resources reproducibly, securely, and with full version control and team collaboration."
        },
        {
          "icon": "fa fa-chart-line",
          "title": "Auto Scaling Systems",
          "desc": "Dynamic auto-scaling that grows your infrastructure in real time during traffic spikes and scales down during quiet periods to optimise cost without compromise."
        }
      ]
    },
    "process": {
      "subtitle": "How We Deliver",
      "title": "Our DevOps Delivery Process",
      "steps": [
        {
          "num": "01",
          "title": "Assessment & Planning",
          "desc": "We audit your current infrastructure, development workflow, and pain points to design the optimal DevOps strategy."
        },
        {
          "num": "02",
          "title": "Architecture Design",
          "desc": "Cloud architecture diagrams, pipeline blueprints, and IaC templates are designed and reviewed before implementation."
        },
        {
          "num": "03",
          "title": "Implementation",
          "desc": "Pipelines, containers, and infrastructure are built, tested in staging, and rolled out with zero downtime strategies."
        },
        {
          "num": "04",
          "title": "Monitoring & Optimisation",
          "desc": "Ongoing observability with dashboards, alerts, and cost optimisation reviews to keep your infrastructure lean and reliable."
        }
      ]
    }
  },
  "vps-hosting": {
    "slug": "vps-hosting",
    "title": "VPS & Hosting",
    "heroIcon": "fa fa-server",
    "heroBg": "/assets/images/photo-1558494949-ef010cbdcc31.jpg",
    "overview": {
      "subtitle": "Hosting Solutions",
      "title": "What We Provide",
      "desc": "Slow hosting costs you customers. We provision, configure, and manage hosting environments that are optimised for speed, security, and 99.9% uptime \u2014 from entry-level VPS to enterprise dedicated servers \u2014 so you can focus on your business, not your infrastructure.",
      "checklist": [
        "SSD-backed servers with NVMe options for maximum I/O performance",
        "Full server setup including OS hardening, firewall, and SSL configuration",
        "cPanel / Plesk for easy management of sites, email, and DNS",
        "Daily automated backups with fast restore capabilities",
        "24/7 monitoring with proactive alerts and rapid response"
      ]
    },
    "subServices": {
      "subtitle": "Hosting Solutions",
      "title": "What We Provide",
      "items": [
        {
          "icon": "fa fa-cloud",
          "title": "VPS & Hosting",
          "desc": "Reliable and scalable hosting solutions"
        },
        {
          "icon": "fa fa-server",
          "title": "Managed VPS Setup",
          "desc": "Fully managed virtual private server configuration"
        },
        {
          "icon": "fa fa-bolt",
          "title": "High-Performance Hosting",
          "desc": "Fast, secure, and optimized hosting services"
        },
        {
          "icon": "fa fa-desktop",
          "title": "cPanel / Plesk Configuration",
          "desc": "Easy server and website management setup"
        },
        {
          "icon": "fa fa-hdd",
          "title": "Dedicated Server Setup",
          "desc": "Powerful dedicated server deployment and management"
        }
      ]
    },
    "process": {
      "subtitle": "How We Work",
      "title": "Our Hosting Setup Process",
      "steps": [
        {
          "num": "01",
          "title": "Requirements Analysis",
          "desc": "We assess your traffic, application stack, storage needs, and budget to recommend the optimal hosting solution."
        },
        {
          "num": "02",
          "title": "Server Provisioning",
          "desc": "Server is ordered, provisioned, and the OS is installed and hardened according to security best practices."
        },
        {
          "num": "03",
          "title": "Configuration & Testing",
          "desc": "Web server, databases, control panel, SSL, and caching layers are configured and load-tested before go-live."
        },
        {
          "num": "04",
          "title": "Go Live & Support",
          "desc": "Your site goes live with monitoring in place. We provide ongoing support, updates, and backups."
        }
      ]
    }
  },
  "aws-cloud-platforms": {
    "slug": "aws-cloud-platforms",
    "title": "AWS & Cloud Platforms",
    "heroIcon": "fa fa-cloud-upload-alt",
    "heroBg": "/assets/images/photo-1667372393119-3d4c48d07fc9.jpg",
    "overview": {
      "subtitle": "Cloud Services We Offer",
      "title": "What We Build in the Cloud",
      "desc": "Cloud is the backbone of modern business. We architect, deploy, and optimise cloud environments across the world's leading platforms \u2014 AWS, GCP, and Azure \u2014 with a focus on reliability, security, and cost efficiency. From a simple EC2 instance to a complex multi-region, multi-cloud deployment, we have the expertise to get it right.",
      "checklist": [
        "AWS Certified engineers with hands-on production experience",
        "Right-sized infrastructure to maximise performance and minimise cost",
        "VPC, IAM, Security Groups, and KMS configured from the ground up",
        "Disaster recovery and multi-AZ high availability by default",
        "Cloud cost optimisation audits that typically save 20\u201340% on cloud bills"
      ]
    },
    "subServices": {
      "subtitle": "Cloud Services We Offer",
      "title": "What We Build in the Cloud",
      "items": [
        {
          "icon": "fa fa-server",
          "title": "AWS EC2 Deployment",
          "desc": "Scalable virtual server setup and management"
        },
        {
          "icon": "fa fa-database",
          "title": "S3 Storage & Backup Solutions",
          "desc": "Secure cloud storage and automated backup systems"
        },
        {
          "icon": "fa fa-bolt",
          "title": "AWS Lambda (Serverless Apps)",
          "desc": "Event-driven serverless application development"
        },
        {
          "icon": "fa fa-project-diagram",
          "title": "Cloud Architecture Design",
          "desc": "Designing secure, scalable, and high-performance cloud systems"
        }
      ]
    },
    "process": {
      "subtitle": "Our Cloud Journey",
      "title": "How We Deliver Your Cloud",
      "steps": [
        {
          "num": "01",
          "title": "Cloud Assessment",
          "desc": "We review your current infrastructure, workloads, and goals to design the optimal cloud strategy and platform mix."
        },
        {
          "num": "02",
          "title": "Architecture Blueprint",
          "desc": "Detailed architecture diagrams, cost estimates, and security models are created and reviewed before any work begins."
        },
        {
          "num": "03",
          "title": "Migration & Setup",
          "desc": "Infrastructure is provisioned via IaC, services are configured, and applications are migrated with zero-downtime strategies."
        },
        {
          "num": "04",
          "title": "Optimisation & Scaling",
          "desc": "Ongoing cost reviews, performance tuning, and capacity planning to keep your cloud efficient and ready for growth."
        }
      ]
    }
  },
  "server-management": {
    "slug": "server-management",
    "title": "Server Management",
    "heroIcon": "fa fa-cogs",
    "heroBg": "/assets/images/photo-1558227691-41ea78d1f631.jpg",
    "overview": {
      "subtitle": "Management Services",
      "title": "What We Manage For You",
      "desc": "Your server is the heartbeat of your business. Our server management service ensures it stays secure, fast, and up \u2014 around the clock. From routine maintenance to emergency response, our Linux experts have seen it all and can keep your infrastructure performing at peak efficiency.",
      "checklist": [
        "Expert management of Ubuntu, Debian, CentOS, AlmaLinux, and RHEL",
        "Proactive security patching and OS updates on a regular schedule",
        "Web server configuration and optimisation for Nginx and Apache",
        "24/7 monitoring with real-time alerting and automated recovery",
        "Root-cause analysis and detailed incident reports for every outage"
      ]
    },
    "subServices": {
      "subtitle": "Management Services",
      "title": "What We Manage For You",
      "items": [
        {
          "icon": "fa fa-cogs",
          "title": "Server Management",
          "desc": "Complete server setup, monitoring, and maintenance"
        },
        {
          "icon": "fa fa-terminal",
          "title": "Linux Server Administration",
          "desc": "Secure and efficient Linux server management"
        },
        {
          "icon": "fa fa-tachometer-alt",
          "title": "Nginx / Apache Optimization",
          "desc": "Web server configuration for speed and performance"
        },
        {
          "icon": "fa fa-headset",
          "title": "24/7 Monitoring & Support",
          "desc": "Continuous server monitoring and technical support"
        },
        {
          "icon": "fa fa-sliders-h",
          "title": "Performance Tuning",
          "desc": "Optimization for maximum speed, stability, and reliability"
        }
      ]
    },
    "process": {
      "subtitle": "How We Work",
      "title": "Our Server Management Process",
      "steps": [
        {
          "num": "01",
          "title": "Server Audit",
          "desc": "We conduct a thorough audit of your current server configuration, security posture, and performance bottlenecks."
        },
        {
          "num": "02",
          "title": "Configuration & Hardening",
          "desc": "Security hardening, software updates, and configuration optimisations are applied using infrastructure best practices."
        },
        {
          "num": "03",
          "title": "Monitoring Setup",
          "desc": "Monitoring dashboards, alerting rules, and log aggregation are configured for 24/7 visibility into your server health."
        },
        {
          "num": "04",
          "title": "Ongoing Management",
          "desc": "Regular maintenance windows, security patches, performance reviews, and 24/7 on-call support keep everything running."
        }
      ]
    }
  },
  "ai-data": {
    "slug": "ai-data",
    "title": "AI & Data",
    "heroIcon": "fa fa-brain",
    "heroBg": "/assets/images/photo-1527474305487-b87b222841cc.jpg",
    "overview": {
      "subtitle": "AI & Data Solutions",
      "title": "What We Offer",
      "desc": "Data is only valuable if you can act on it. We build machine learning models, interactive dashboards, intelligent chatbots, and robotic process automation setups that turn raw data into a competitive advantage \u2014 helping you save costs, improve workflows, and predict market trends.",
      "checklist": [
        "Custom machine learning models tailored to your business needs",
        "Interactive, real-time data analytics dashboards (PowerBI, Tableau, custom web apps)",
        "Intelligent AI chatbots integrated with your knowledge bases",
        "Workflow automation setups that save hundreds of hours of manual labor",
        "Robust, compliant data pipeline architectures"
      ]
    },
    "subServices": {
      "subtitle": "AI & Data Solutions",
      "title": "What We Offer",
      "items": [
        {
          "icon": "fa fa-brain",
          "title": "AI & Data",
          "desc": "Intelligent solutions powered by data and artificial intelligence"
        },
        {
          "icon": "fa fa-microchip",
          "title": "Machine Learning Solutions",
          "desc": "Custom ML models for prediction and automation"
        },
        {
          "icon": "fa fa-chart-pie",
          "title": "Data Analytics Dashboards",
          "desc": "Interactive dashboards for real-time insights and reporting"
        },
        {
          "icon": "fa fa-comments",
          "title": "AI Chatbots",
          "desc": "Smart conversational bots for customer support and engagement"
        },
        {
          "icon": "fa fa-cog",
          "title": "Automation Systems",
          "desc": "AI-driven workflow and business process automation"
        }
      ]
    },
    "process": {
      "subtitle": "Our Methodology",
      "title": "Our AI Development Process",
      "steps": [
        {
          "num": "01",
          "title": "Data Discovery",
          "desc": "We analyze your existing data sources, business metrics, and target problems to assess feasibility."
        },
        {
          "num": "02",
          "title": "Model & Pipeline Design",
          "desc": "We build robust data pipelines and prototype ML algorithms or dashboard layouts for review."
        },
        {
          "num": "03",
          "title": "Development & Training",
          "desc": "We train the models, build interfaces, integrate system APIs, and test accuracy and performance."
        },
        {
          "num": "04",
          "title": "Deployment & Auditing",
          "desc": "We launch the solution, monitor decision quality, and continuously train algorithms on fresh data."
        }
      ]
    }
  },
  "cybersecurity": {
    "slug": "cybersecurity",
    "title": "Cybersecurity",
    "heroIcon": "fa fa-shield-alt",
    "heroBg": "/assets/images/photo-1550751827-4bd374c3f58b.jpg",
    "overview": {
      "subtitle": "Security Domains",
      "title": "What We Audit & Protect",
      "desc": "One security breach can destroy years of customer trust. We defend your digital presence with comprehensive vulnerability assessments, penetration testing, strict compliance frameworks, and network security hardening. Our cybersecurity experts make sure your servers, applications, and networks remain impenetrable.",
      "checklist": [
        "Thorough security audits spanning source code, infrastructure, and user access",
        "Penetration testing to identify and patch security flaws before exploiters do",
        "SSL setup, secure headers, and end-to-end data encryption configuration",
        "Compliance assistance for GDPR, ISO 27001, and local Middle East & African Regionsecurity guidelines",
        "Firewall setup, intrusion detection systems, and DDOS mitigation integration"
      ]
    },
    "subServices": {
      "subtitle": "Security Domains",
      "title": "What We Audit & Protect",
      "items": [
        {
          "icon": "fa fa-shield-alt",
          "title": "Cybersecurity",
          "desc": "End-to-end protection for digital systems and data"
        },
        {
          "icon": "fa fa-search",
          "title": "Security Audits",
          "desc": "Detailed assessment of system vulnerabilities and risks"
        },
        {
          "icon": "fa fa-user-secret",
          "title": "Penetration Testing",
          "desc": "Ethical hacking to identify and fix security weaknesses"
        },
        {
          "icon": "fa fa-lock",
          "title": "SSL & Encryption",
          "desc": "Secure data transmission with advanced encryption methods"
        },
        {
          "icon": "fa fa-file-invoice",
          "title": "Compliance (GDPR, etc.)",
          "desc": "Ensuring adherence to global data protection standards"
        }
      ]
    },
    "process": {
      "subtitle": "Security Cycle",
      "title": "Our Auditing Workflow",
      "steps": [
        {
          "num": "01",
          "title": "Vulnerability Scan",
          "desc": "Automated and manual reviews scanning for known security bugs, open ports, and configuration flaws."
        },
        {
          "num": "02",
          "title": "Deep Audit & Pen-Test",
          "desc": "Active penetration testing probing deeply for complex logical vulnerabilities, access control bypasses, and script injections."
        },
        {
          "num": "03",
          "title": "Detailed Reporting",
          "desc": "We deliver an prioritized list of vulnerabilities alongside clear steps for your development team to patch them."
        },
        {
          "num": "04",
          "title": "Re-Testing & Hardening",
          "desc": "We verify applied patches, configure security policies, firewalls, and logging alerts to block future threats."
        }
      ]
    }
  },
  "migration-maintenance": {
    "slug": "migration-maintenance",
    "title": "Migration & Maintenance",
    "heroIcon": "fa fa-sync-alt",
    "heroBg": "/assets/images/photo-1544383835-bda2bc66a55d.jpg",
    "overview": {
      "subtitle": "Service Areas",
      "title": "What We Migrate & Maintain",
      "desc": "Migrating servers or database systems can feel like performing open-heart surgery on your business. We take the stress out of the process with structured, tested migrations designed for zero disruption. Post-launch, we keep your systems updated, fast, and completely secure with ongoing, scheduled maintenance checks.",
      "checklist": [
        "Seamless site and host migration with zero data loss or downtime",
        "Physical-to-virtual (P2V) and cloud-to-cloud server migration",
        "Secure database transfer, schema conversion, and verification",
        "Ongoing security patching, system software updates, and speed audits",
        "Quick-response support SLA to handle any platform issues"
      ]
    },
    "subServices": {
      "subtitle": "Service Areas",
      "title": "What We Migrate & Maintain",
      "items": [
        {
          "icon": "fa fa-sync-alt",
          "title": "Migration & Maintenance",
          "desc": "Secure and seamless migration with continuous support"
        },
        {
          "icon": "fa fa-globe",
          "title": "Website Migration",
          "desc": "Safe transfer of websites with zero data loss and minimal downtime"
        },
        {
          "icon": "fa fa-server",
          "title": "Server Migration",
          "desc": "Smooth relocation of servers with optimized performance setup"
        },
        {
          "icon": "fa fa-database",
          "title": "Database Transfer",
          "desc": "Accurate and secure migration of databases between systems"
        },
        {
          "icon": "fa fa-tools",
          "title": "Ongoing Maintenance & Support",
          "desc": "Regular updates, monitoring, and technical support for stability"
        }
      ]
    },
    "process": {
      "subtitle": "Migration Lifecycle",
      "title": "Our Migration Process",
      "steps": [
        {
          "num": "01",
          "title": "Audit & Planning",
          "desc": "We inventory all system assets, databases, configuration requirements, and plan the migration window."
        },
        {
          "num": "02",
          "title": "Target Setup",
          "desc": "We provision and configure the new hosting or server environment according to target specifications."
        },
        {
          "num": "03",
          "title": "Sync & Validation",
          "desc": "Data is migrated, DNS is updated, and all database values are verified under testing conditions."
        },
        {
          "num": "04",
          "title": "Go-Live & Support",
          "desc": "We shift traffic to the new setup, verify telemetry metrics, and begin ongoing maintenance routines."
        }
      ]
    }
  }
};
